// extracted by mini-css-extract-plugin
export default {"turnOffAlignment":"register-of-bets-create-pate_turnOffAlignment__LnpKG"};